import { accessControlsConstants } from "../_constants";

export function createAccessControl(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_SUCCESS:
      return {
        item: action.data,
      };
    case accessControlsConstants.CREATE_NEW_ACCESS_CONTROL_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessControlsList(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GETALL_ACCESS_CONTROLS_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GETALL_ACCESS_CONTROLS_SUCCESS:
      return {
        items: action.accessControls,
      };
    case accessControlsConstants.GETALL_ACCESS_CONTROLS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activeRoles(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GETALL_ACTIVE_ROLES_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GETALL_ACTIVE_ROLES_SUCCESS:
      return {
        items: action.activeRoles,
      };
    case accessControlsConstants.GETALL_ACTIVE_ROLES_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessControlsPoliciesList(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_SUCCESS:
      return {
        items: action.accessControlPolicies,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_POLICIES_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessControlsDetails(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_SUCCESS:
      return {
        items: action.accessControl,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_DETAILS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessControlsTopCards(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_SUCCESS:
      return {
        items: action.accessControlsTopCardInfo,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_TOP_CARD_INFO_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function accessControlFilters(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.GET_ACCESS_CONTROL_FILTER_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_FILTER_SUCCESS:
      return {
        items: action.filtersAccessControl,
      };
    case accessControlsConstants.GET_ACCESS_CONTROL_FILTER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function activateAccessControl(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_SUCCESS:
      return {
        item: action.data,
      };
    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function updateAccessControlPolicies(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_SUCCESS:
      return {
        items: action.accessControlPolices,
      };
    case accessControlsConstants.ACCESS_CONTROL_POLICIES_UPDATE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function deleteRole(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.DELETE_ROLE_REQUEST:
      return {
        loading: true,
      };
    case accessControlsConstants.DELETE_ROLE_SUCCESS:
      return {
        item: action.data,
      };
    case accessControlsConstants.DELETE_ROLE_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//navigationList
export function navigationList(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.FETCH_ALL_UI_NAVIGATION_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.FETCH_ALL_UI_NAVIGATION_SUCCESS:
      return {
        item: action.navigationList,
      }
    case accessControlsConstants.FETCH_ALL_UI_NAVIGATION_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//assignedUiNav
export function assignedUiNav(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.UPDATE_UI_NAVIGATION_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.UPDATE_UI_NAVIGATION_SUCCESS:
      return {
        item: action.assignedUiNav,
      }
    case accessControlsConstants.UPDATE_UI_NAVIGATION_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//fetch uiNavigation By roleId
export function UiNavigationById(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.FETCH_UI_NAVIGATION_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.FETCH_UI_NAVIGATION_SUCCESS:
      return {
        item: action.data,
      }
    case accessControlsConstants.FETCH_UI_NAVIGATION_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//AccessPolicyList
export function accessPolicyList(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.FETCH_POLICIES_LIST_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.FETCH_POLICIES_LIST_SUCCESS:
      return {
        item: action.policiesList,
      }
    case accessControlsConstants.FETCH_POLICIES_LIST_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//unAssign
export function unAssignNavigation(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.UNASSIGN_UI_NAVIGATION_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.UNASSIGN_UI_NAVIGATION_SUCCESS:
      return {
        item: action.unassign,
      }
    case accessControlsConstants.UNASSIGN_UI_NAVIGATION_FAILURE:
      return {
        error: action.error,
      }
    default:
      return state;
  }
}
//updateAccessControl
export function updateRole(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.UPDATE_ACCESS_CONTROLS_REQUEST:
      return {
        loading: true,
      }
    case accessControlsConstants.UPDATE_ACCESS_CONTROLS_SUCCESS:
        return {
        item: action.data,
      };
    case accessControlsConstants.UPDATE_ACCESS_CONTROLS_FAILURE:
      return action.error;
    default:
      return state;
  }
}



